import { render, staticRenderFns } from "./AddPaymentNotification.vue?vue&type=template&id=35d70c22&scoped=true&"
import script from "./AddPaymentNotification.vue?vue&type=script&lang=js&"
export * from "./AddPaymentNotification.vue?vue&type=script&lang=js&"
import style0 from "./AddPaymentNotification.vue?vue&type=style&index=0&id=35d70c22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d70c22",
  null
  
)

export default component.exports